import React, { useCallback, useState } from 'react';
import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition, } from '@atlaskit/modal-dialog';
var STORE_FEEDBACK_KEY_BASE = "credoAutomationFeedback";
function getFeedbackSurveyKey(serviceId) {
    return "0.1-" + STORE_FEEDBACK_KEY_BASE + "-" + serviceId;
}
function enableFeedBackSurvey(serviceId) {
    localStorage.setItem(getFeedbackSurveyKey(serviceId), String(true));
}
function disableFeedBackSurvey(serviceId) {
    localStorage.setItem(getFeedbackSurveyKey(serviceId), String(false));
}
var FeedbackSurvey = function (_a) {
    var serviceId = _a.serviceId;
    var _b = useState(localStorage.getItem(getFeedbackSurveyKey(serviceId)) || 'false'), isOpen = _b[0], setIsOpen = _b[1];
    var closeModal = useCallback(function () {
        disableFeedBackSurvey(serviceId);
        setIsOpen('false');
    }, [serviceId]);
    return (React.createElement(ModalTransition, null, isOpen === 'true' && (React.createElement(Modal, { onClose: closeModal },
        React.createElement(ModalHeader, null,
            React.createElement(ModalTitle, null, "Feedback Survey")),
        React.createElement(ModalBody, null, "Congratulations on getting your service Credo certified. Your feedback is valuable in making Credo an even better experience!"),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { appearance: "subtle", onClick: closeModal }, "No! I will take this survey later."),
            React.createElement(Button, { appearance: "primary", onClick: function () {
                    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfEvcS2yUK6nGI4--thhHfi2_sw3Ua60WViL_QH4JTOwQqcPw/viewform', "_blank", "noopener noreferrer");
                    closeModal();
                }, autoFocus: true }, "Yes! Open the survey in new tab."))))));
};
export { FeedbackSurvey, enableFeedBackSurvey };
